import { render, staticRenderFns } from "./PackageSummary.vue?vue&type=template&id=7ad4353f&scoped=true"
import script from "./PackageSummary.vue?vue&type=script&lang=ts"
export * from "./PackageSummary.vue?vue&type=script&lang=ts"
import style0 from "./PackageSummary.vue?vue&type=style&index=0&id=7ad4353f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad4353f",
  null
  
)

export default component.exports